import React from 'react'
import "./hero.css"


const Hero = () => {
  return (
    <>
      <section className="hero">
        <div className="container">
            <img src="./images/image2.png" alt="" />
        </div>
  
      </section>
    </>
  )
}

export default Hero
